// @flow weak

import localforage from 'localforage';
import * as R from 'ramda';

import { AceService } from '~/services';
import {
  isReactNativeAceWebView,
  MESSAGE_CHANGE_EMAIL,
  MESSAGE_CHANGE_PASSWORD,
  MESSAGE_GET_AUTH_TOKENS,
  MESSAGE_GET_ELEVATE_TOKENS,
  MESSAGE_SET_APP_VERSION,
  MESSAGE_SET_APP_VERSION_STRING,
  MESSAGE_SET_AUTH_TOKENS,
  MESSAGE_SET_ELEVATE_TOKENS,
  MESSAGE_SETUP_MFA,
  MESSAGE_SIGN_IN,
  MESSAGE_SIGN_OUT,
  MESSAGE_SIGN_UP,
  MESSAGE_SET_LOCALE,
  STORAGE_KEY_LOCALE,
} from '~/helpers';

const {
  REACT_APP_DOWNLOAD_MOBILE_APP_ENDPOINT,
  REACT_APP_VERSION,
} = process.env;

const handlers = {
  [MESSAGE_CHANGE_EMAIL]: () => AceService.changeEmail(),
  [MESSAGE_CHANGE_PASSWORD]: () => AceService.changePassword(),
  [MESSAGE_GET_AUTH_TOKENS]: async () =>
    setAuthTokens(await AceService.getAuthTokens()),
  [MESSAGE_GET_ELEVATE_TOKENS]: () => AceService.elevate(),
  [MESSAGE_SET_LOCALE]: ({ locale }) =>
    localforage.setItem(STORAGE_KEY_LOCALE, locale),
  [MESSAGE_SETUP_MFA]: () => AceService.changeAuth(),
  [MESSAGE_SIGN_IN]: async () => setAuthTokens(await AceService.signIn()),
  [MESSAGE_SIGN_OUT]: () => AceService.signOut(),
  [MESSAGE_SIGN_UP]: () => AceService.signUp(),
};

const handleMessage = ({ data }) => {
  const { message, body = {} } = R.tryCatch(JSON.parse, R.always({}))(data);

  if (!handlers[message]) {
    return;
  }

  handlers[message](body);
};

const postMessage = (message, body) => {
  try {
    if (isReactNativeAceWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ message, body }));
    }
  } catch (e) {}
};

export const setAppVersion = () => {
  // TODO: Do next changes in future releases (version backward compatibility):
  // 1. Remove "dataOldFormat" config object and "postMessage(MESSAGE_SET_APP_VERSION, dataOldFormat);"
  // 2. Remove "MESSAGE_SET_APP_VERSION"
  // 3. Rename "MESSAGE_SET_APP_VERSION_STRING" to "MESSAGE_SET_APP_VERSION"
  // 4. Rename "dataNewFormat" config object to "data"
  // 5. Search code in whole project using flag "version backward compatibility" and make described changes
  const dataOldFormat = {
    downloadUrl: REACT_APP_DOWNLOAD_MOBILE_APP_ENDPOINT,
    version: {
      mobile: REACT_APP_VERSION,
      web: '0.0.0',
    },
  };
  const dataNewFormat = {
    downloadUrl: REACT_APP_DOWNLOAD_MOBILE_APP_ENDPOINT,
    version: REACT_APP_VERSION,
  };

  postMessage(MESSAGE_SET_APP_VERSION, dataOldFormat);
  postMessage(MESSAGE_SET_APP_VERSION_STRING, dataNewFormat);
};

export const setAuthTokens = authTokens =>
  postMessage(MESSAGE_SET_AUTH_TOKENS, { authTokens });

export const setElevateTokens = elevateTokens =>
  postMessage(MESSAGE_SET_ELEVATE_TOKENS, { elevateTokens });

if (isReactNativeAceWebView) {
  document.addEventListener('message', handleMessage);
}
